// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iz_a bik_ss","PhotoTitleEditForm__cancelBtn":"iz_b bik_sw bik_sv"};